var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxStopwatchBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 6.66602C10.1193 6.66602 5.33398 11.4513 5.33398 17.3327C5.33398 23.214 10.1193 27.9993 16.0007 27.9993C21.882 27.9993 26.6673 23.214 26.6673 17.3327C26.6673 11.4513 21.882 6.66602 16.0007 6.66602ZM16.0007 25.3327C11.5887 25.3327 8.00065 21.7447 8.00065 17.3327C8.00065 12.9207 11.5887 9.33268 16.0007 9.33268C20.4127 9.33268 24.0007 12.9207 24.0007 17.3327C24.0007 21.7447 20.4127 25.3327 16.0007 25.3327Z",
    fill: "#2E3BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 11.9993H17.3333V18.666H14.6667V11.9993ZM12 2.66602H20V5.33268H12V2.66602ZM25.724 10.2753L23.0573 7.60868L24.9427 5.72335L27.6093 8.39002L25.724 10.2753Z",
    fill: "#2E3BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxStopwatchBlue);
export default __webpack_public_path__ + "static/media/bx-stopwatch-blue.fedb46f96ec85fe2296fecf1f6a60031.svg";
export { ForwardRef as ReactComponent };